import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Input, Button, Tooltip, message } from "antd";
import PropTypes from "prop-types";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_tqa_b03,
  req_downloadfile_tqa_b03,
  req_delete_tqa_a05,
  req_add_tqa_a05,
  req_copy_tqa_b03,
  req_edit_tqa_b03,
} from "../../api";

class CollegeQuailtyB05 extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    department: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    rooms: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    academicYear: this.props.department.AcademicYear,
    isShowDetailsModal: false,
    isUploadModal: false,
    recordDescription: "",
    startdate: "",
    enddate: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { DepartmentCode } = this.props.department;
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_tqa_b03(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      DepartmentCode,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { DepartmentCode } = this.props.department;
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_tqa_b03(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      DepartmentCode,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_copy_item = async (oldYear, newYear) => {
    const { token, userCode } = this.props.user;
    const { DepartmentCode } = this.props.department;
    const result = await req_copy_tqa_b03(
      oldYear,
      newYear,
      DepartmentCode,
      userCode,
      token
    );

    if (result.status === "success") {
      message.success("複製成功");
      this.api_page_items(this.current);
    } else {
      message.info(newYear + "年度已有資料，複製失敗");
    }
  };

  api_edit_item = async (row) => {
    const token = this.props.user.token;

    //console.log(row)
    const result = await req_edit_tqa_b03(row, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("編輯成功");
      this.setState({ isShowModal_edit_item: false });
      // 2 更新列表
      this.api_page_items(this.current);
    } else {
      console.log(result);
    }
  };

  api_delete_relation_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_tqa_a05(key, token);
    if (result.status === "success") {
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_add_relation_item = async (row) => {
    const token = this.props.user.token;
    const result = await req_add_tqa_a05(row, token);
    if (result.status === "success") {
      // 2 更新列表
      this.api_page_items(this.current);
    } else {
      //console.log(result);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        fixed: "left",
      },
      {
        title: "部門名稱",
        dataIndex: "DepartmentName",
        width: 25,
        fixed: "left",
      },
      {
        title: "核心能力",
        width: 40,
        render: (item) => {
          const { RecordDescription } = item;
          return <>{RecordDescription}</>;
        },
      },
      {
        title: "與校核心能力關聯",
        width: 50,
        fixed: "right",
        render: (item) => {
          const { ColumnDescription, RelationUid, RecordStatus } = item;
          return (
            <>
              <button
                className={
                  RelationUid === "UNCHECKED"
                    ? "btn btn-outline-dark btn-sm"
                    : "btn btn-outline-success btn-sm"
                }
                onClick={() => this.handle_ui_modal("RELATION", item)}
                disabled={RecordStatus === "DONE"}
              >
                {RelationUid === "UNCHECKED" ? "無相關" : ColumnDescription}
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  onChangeTextArea = (e, item) => {
    Object.keys(item).forEach((propertyName) => {
      if (e.target.id === propertyName && e.target.value !== null) {
        item[propertyName] = e.target.value.trim();
      }
    });
    this.setState({ item });
  };
  onChangeInput = (e, item) => {
    //console.log(e.target.value);
    this.setState({
      recordDescription: e.target.value,
    });
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_switch_change = (checked, item) => {
    //   const { userCode } = this.props.user;
    //   const { AcademicYear, DepartmentCode, RecordNumber, RelationUid } =
    //   item;
    // if (RelationUid === "UNCHECKED") {
    //   const addObj = {
    //     AcademicYear: AcademicYear,
    //     ColumnField: "1",
    //     RowField: DepartmentCode + RecordNumber,
    //     RecordCreator: userCode,
    //   };
    //   this.api_add_a02_item(addObj);
    // } else {
    //   this.api_delete_a02_item(RelationUid);
  };

  handle_ui_modal = (type, item) => {
    //console.log(item);
    const { userCode } = this.props.user;
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "COPY":
        const { academicYear } = this.state;
        this.api_copy_item(
          academicYear,
          (parseInt(academicYear) + 1).toString()
        );
        break;
      case "EDIT":
        const { Uid, RecordDescription, RecordTitle } = item;
        const obj = {
          Uid,
          RecordDescription: RecordDescription,
          RecordTitle: RecordTitle,
          RecordEditor: userCode,
          condition: "BASE",
        };
        this.api_edit_item(obj);
        break;
      case "RELATION":
        const { AcademicYear, DepartmentCode, RecordNumber, RelationUid } =
          item;
        if (RelationUid === "UNCHECKED") {
          const addObj = {
            AcademicYear: AcademicYear,
            ColumnField: "1",
            RowField: DepartmentCode + RecordNumber,
            RecordCreator: userCode,
          };
          this.api_add_relation_item(addObj);
        } else {
          this.api_delete_relation_item(RelationUid);
        }
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, academicYear } = this.state;
    const workmenu = (
      <>
        {this.props.department.condition === "CANEDIT" ? (
          <>
            {" "}
            <Input
              placeholder="學年度"
              style={{
                width: 55,
                margin: "0 5px",
                backgroundColor: "LightYellow",
              }}
              value={academicYear}
              onChange={(event) =>
                this.setState({ academicYear: event.target.value })
              }
            />
            <Tooltip placement="top" title="重新整理">
              <Button
                type="primary"
                onClick={() => this.handle_data_refresh()}
                style={{ marginRight: "4px" }}
              >
                <i className="fas fa-sync-alt"></i>
              </Button>
            </Tooltip>
            {items.length > 0 && (
              <Button
                type="primary"
                onClick={() => this.handle_ui_modal("COPY", {})}
              >
                <i
                  className="fa fa-object-ungroup"
                  style={{ paddingRight: "2px" }}
                ></i>
                複製
              </Button>
            )}
          </>
        ) : (
          ""
        )}
        <Button
          type="primary"
          onClick={() => this.handle_ui_modal("EXPORT", {})}
          style={{ marginRight: "4px" }}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "2px" }}></i>
          匯出
        </Button>
        <p></p>
      </>
    );

    return (
      <>
        <Card title="B05-校核心能力與院(中心)學生核心能力關聯表">
          {workmenu}
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect(
  (state) => ({ user: state.user }),
  {}
)(CollegeQuailtyB05);
